import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditActivityFileType extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "activity_file_type";
    }
}
